import {
  FETCH_HANDLER_PROFILE_REQUEST,
  FETCH_HANDLER_PROFILE_SUCCESS,
  FETCH_HANDLER_PROFILE_FAILURE,
  CHECK_HANDLER_PROFILE,
  PATCH_HANDLER_REQUEST,
  PATCH_HANDLER_SUCCESS,
  PATCH_HANDLER_FAILURE
} from './handlerTypes';
import { getAuthClient } from '../../library/drupal/DrupalAuth2';

const auth = getAuthClient();

// === Resource/type constants (prefilled) ===
const CONFIRM_RESOURCE = 'handler_packet_confirmation';             // JSON:API collection path segment
const CONFIRM_TYPE = 'node--handler_packet_confirmation';           // JSON:API resource type
const HANDLER_TYPE = 'node--handler';
const SEASON_TYPE = 'node--season';

// === Field names (as confirmed) ===
const FIELD_BOOL_ON_CONFIRM = 'field_handler_packet_confirm';       // boolean on confirmation node
const FIELD_RELATION_HANDLER_ON_CONFIRM = 'field_handler';          // confirmation -> handler
const FIELD_RELATION_SEASON_ON_CONFIRM = 'field_season';            // confirmation -> season
const FIELD_CONFIRMS_ON_HANDLER = 'field_handler_packet_confirms';  // handler -> [confirmations]

const FIELD_CERTIFICATION_DATETIME = 'field_certification_datetime';
const FIELD_CERTIFICATION_NAME = 'field_certification_name';

// ---------------- Existing actions (unchanged) ----------------
export const fetchHandlerProfile = (handlerUID) => {
  if (handlerUID !== null) {
    const url = '/jsonapi/node/handler/' + handlerUID + '?include=field_handler_analytics,field_handler_packet_confirms';
    const options = {
      method: 'GET',
      headers: new Headers({
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
      }),
      mode: 'cors',
    };
    return async (dispatch) => {
      dispatch(fetchHandlerProfileRequest());
      try {
        const response = await auth.fetchWithAuthentication(url, options);
        if (response.ok) {
          const data = await response.json();
          const handlerProfile = data.data;
          const handlerName = handlerProfile['title'];
          const handlerNumber = handlerProfile['field_handler_number'];
          const handlerStatus = handlerProfile['field_handler_status'];
          localStorage.setItem('handler_name', handlerName);
          localStorage.setItem('handler_number', handlerNumber);
          localStorage.setItem('handler_status', handlerStatus);
          localStorage.setItem('handler_profile', JSON.stringify(handlerProfile));
          await dispatch(fetchHandlerProfileSuccess(handlerName, handlerNumber, handlerStatus, handlerProfile));
        } else {
          throw new Error('message: ' + response.status);
        }
      } catch (error) {
        const errorMsg = error.message;
        dispatch(fetchHandlerProfileFailure(errorMsg));
      }
    }
  }
};

export const setHandlerPacketConfirm = (handlerUID, data) => {
  const url = '/jsonapi/node/handler/' + handlerUID;
  const options = {
    method: 'PATCH',
    headers: new Headers({
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }),
    mode: 'cors',
    body: JSON.stringify(data)
  };
  return async (dispatch) => {
    dispatch(patchHandlerRequest());
    try {
      const response = await auth.fetchWithAuthentication(url, options);
      if (response.ok) {
        dispatch(patchHandlerSuccess());
        let handlerUIDLocal = null;
        try {
          handlerUIDLocal = localStorage.getItem('handler_uid');
        } catch (e) {}
        await dispatch(fetchHandlerProfile(handlerUIDLocal));
      } else {
        dispatch(patchHandlerFailure('An error has occured.'));
      }
    } catch (error) {
      const errorMsg = error.message;
      dispatch(patchHandlerFailure(errorMsg));
    }
  }
};

// ---------------- NEW: upsert a confirmation for current season ----------------
async function attachConfirmToHandler(handlerId, confirmId, auth) {
  var relUrl = '/jsonapi/node/handler/' + handlerId + '/relationships/' + FIELD_CONFIRMS_ON_HANDLER;
  var postBody = {
    data: [{ type: CONFIRM_TYPE, id: confirmId }]
  };
  var postOptions = {
    method: 'POST',
    headers: new Headers({
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json'
    }),
    mode: 'cors',
    body: JSON.stringify(postBody)
  };
  var postResp = await auth.fetchWithAuthentication(relUrl, postOptions);
  if (!postResp.ok) {
    throw new Error('Failed to append confirmation to handler: ' + postResp.status);
  }
}

function isoNowSecondsUTC() {
  // 2025-09-11T14:31:00+00:00 (no milliseconds)
  return new Date().toISOString().replace(/\.\d{3}Z$/, '+00:00');
}

export const upsertHandlerPacketConfirm = (currentSeasonID) => {
  return async (dispatch, getState) => {
    dispatch(patchHandlerRequest());

    try {
      var state = getState();
      var handlerReducer = state && state.handlerReducer ? state.handlerReducer : null;
      var seasonReducer  = state && state.seasonReducer ? state.seasonReducer : null;
      var userReducer    = state && state.userReducer ? state.userReducer : null;

      if (!handlerReducer || !handlerReducer.handlerProfile) { throw new Error('Handler profile is not loaded.'); }
      if (!seasonReducer || !seasonReducer.currentSeason)   { throw new Error('Current season is not available.'); }
      if (!currentSeasonID)                                 { throw new Error('Missing current season ID.'); }

      var handlerProfile = handlerReducer.handlerProfile;
      var handlerId = handlerProfile && handlerProfile.id ? handlerProfile.id : null;
      if (!handlerId) { throw new Error('Missing handler ID.'); }

      var handlerNumber = handlerProfile.field_handler_number || '';
      var seasonName = (seasonReducer.currentSeason && seasonReducer.currentSeason.title) ? seasonReducer.currentSeason.title : '';
      var username = (userReducer && userReducer.username) ? userReducer.username : '';
      var nowIso = isoNowSecondsUTC();

      // 1) Search existing confirmation for (handlerId, currentSeasonID)
      var searchUrl = '/jsonapi/node/' + CONFIRM_RESOURCE
        + '?filter[handler][condition][path]=' + FIELD_RELATION_HANDLER_ON_CONFIRM + '.id'
        + '&filter[handler][condition][value]=' + encodeURIComponent(handlerId)
        + '&filter[season][condition][path]=' + FIELD_RELATION_SEASON_ON_CONFIRM + '.id'
        + '&filter[season][condition][value]=' + encodeURIComponent(currentSeasonID)
        + '&page[limit]=1';

      var getOptions = {
        method: 'GET',
        headers: new Headers({
          'Accept': 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json'
        }),
        mode: 'cors'
      };

      var searchResp = await auth.fetchWithAuthentication(searchUrl, getOptions);
      if (!searchResp.ok) { throw new Error('Failed to search existing confirmations: ' + searchResp.status); }
      var searchJson = await searchResp.json();
      var existing = (searchJson && searchJson.data && searchJson.data.length > 0) ? searchJson.data[0] : null;

      var computedTitle = 'Handler Packet Confirmation-' + handlerNumber + '-' + seasonName;

      if (existing && existing.id) {
        // 2) PATCH existing confirmation: set bool true + refresh title + certification fields
        var patchUrl = '/jsonapi/node/' + CONFIRM_RESOURCE + '/' + existing.id;
        var patchBody = {
          data: {
            type: CONFIRM_TYPE,
            id: existing.id,
            attributes: {}
          }
        };
        patchBody.data.attributes[FIELD_BOOL_ON_CONFIRM] = true;
        patchBody.data.attributes['title'] = computedTitle;
        patchBody.data.attributes[FIELD_CERTIFICATION_DATETIME] = nowIso;
        patchBody.data.attributes[FIELD_CERTIFICATION_NAME] = username;

        var patchOptions = {
          method: 'PATCH',
          headers: new Headers({
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
          }),
          mode: 'cors',
          body: JSON.stringify(patchBody)
        };

        var patchResp = await auth.fetchWithAuthentication(patchUrl, patchOptions);
        if (!patchResp.ok) { throw new Error('Failed to update existing confirmation: ' + patchResp.status); }

      } else {
        // 3) CREATE new confirmation with full attributes + relationships
        var postUrl = '/jsonapi/node/' + CONFIRM_RESOURCE;
        var postBody = {
          data: {
            type: CONFIRM_TYPE,
            attributes: {
              title: computedTitle
            },
            relationships: {}
          }
        };
        postBody.data.attributes[FIELD_BOOL_ON_CONFIRM] = true;
        postBody.data.attributes[FIELD_CERTIFICATION_DATETIME] = nowIso;
        postBody.data.attributes[FIELD_CERTIFICATION_NAME] = username;

        postBody.data.relationships[FIELD_RELATION_SEASON_ON_CONFIRM] = {
          data: { type: SEASON_TYPE, id: currentSeasonID }
        };
        postBody.data.relationships[FIELD_RELATION_HANDLER_ON_CONFIRM] = {
          data: { type: HANDLER_TYPE, id: handlerId }
        };

        var postOptions = {
          method: 'POST',
          headers: new Headers({
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
          }),
          mode: 'cors',
          body: JSON.stringify(postBody)
        };

        var postResp = await auth.fetchWithAuthentication(postUrl, postOptions);
        if (!postResp.ok) { throw new Error('Failed to create new confirmation: ' + postResp.status); }
        var created = await postResp.json();
        var createdId = (created && created.data && created.data.id) ? created.data.id : null;

        // 4) Append to handler’s to-many relationship (preserves existing)
        if (createdId) {
          await attachConfirmToHandler(handlerId, createdId, auth);
        }
      }

      // Refresh UI
      dispatch(patchHandlerSuccess());
      var handlerUIDLocal = null;
      try { handlerUIDLocal = localStorage.getItem('handler_uid'); } catch (e) {}
      await dispatch(fetchHandlerProfile(handlerUIDLocal));

    } catch (error) {
      var msg = (error && error.message) ? error.message : 'Unknown error';
      dispatch(patchHandlerFailure(msg));
    }
  };
};


// ---------------- Existing simple action creators (unchanged) ----------------
export const fetchHandlerProfileRequest = () => ({ type: FETCH_HANDLER_PROFILE_REQUEST });
export const fetchHandlerProfileSuccess = (handlerName, handlerNumber, handlerStatus, handlerProfile) => ({
  type: FETCH_HANDLER_PROFILE_SUCCESS,
  handlerName: handlerName,
  handlerNumber: handlerNumber,
  handlerStatus: handlerStatus,
  handlerProfile: handlerProfile
});
export const fetchHandlerProfileFailure = error => ({ type: FETCH_HANDLER_PROFILE_FAILURE, payload: error });
export const checkHandlerProfile = () => ({
  type: CHECK_HANDLER_PROFILE,
  handlerName: localStorage.getItem('handler_name'),
  handlerNumber: localStorage.getItem('handler_number'),
  handlerStatus: localStorage.getItem('handler_status'),
  handlerProfile: JSON.parse(localStorage.getItem('handler_profile'))
});
export const patchHandlerRequest = () => ({ type: PATCH_HANDLER_REQUEST });
export const patchHandlerSuccess = () => ({ type: PATCH_HANDLER_SUCCESS });
export const patchHandlerFailure = (err) => ({ type: PATCH_HANDLER_FAILURE, payload: err });
